import { AppModules, ModuleAction, ModuleInfo } from "@/types/Module.ts";

export class ModuleUtils {
  public static findModuleByPath(path: string): AppModules | undefined {
    if (path === "/") {
      return AppModules.DASHBOARD;
    }

    const modules = (Object.keys(AppModules) as AppModules[])
      .filter((x) => {
        return x !== AppModules.DASHBOARD;
      })
      .map(this.getModuleInfo);
    return modules.find((x) => {
      return path.startsWith(x.path);
    })?.module;
  }

  public static getActionName(action: ModuleAction): string {
    switch (action) {
      case ModuleAction.DETAILS:
        return "Detalles";

      case ModuleAction.UPDATE:
        return "Actualizar";

      case ModuleAction.DELETE:
        return "Eliminar";

      case ModuleAction.TO_LIST:
        return "Listar";

      case ModuleAction.CREATE:
        return "Crear";
      case ModuleAction.CREATE_AND_UPDATE:
        return "Crear y Actualizar";
      case ModuleAction.DISABLE:
        return "Deshabilitar";
      case ModuleAction.ENABLE:
        return "Habilitar";

      case ModuleAction.USERS_CHANGE_PASSWORD:
        return "Cambiar contraseña";

      case ModuleAction.COMPANY_CHANNELS:
        return "Canales";

      case ModuleAction.COMPANY_SUPPORTS:
        return "Material de Apoyo";

      case ModuleAction.COMPANY_SUPPORT_EXPORT:
        return "Exportar Material de Apoyo";

      case ModuleAction.COMPANY_SUPPORT_UPDATE:
        return "Actualizar Material de Apoyo";

      case ModuleAction.COMPANY_TICKETS_LIST:
        return "Listar Tickets";

      case ModuleAction.COMPANY_TICKET_DETAILS:
        return "Detalles de Ticket";

      case ModuleAction.COMPANY_TICKET_UPDATE:
        return "Actualizar Ticket";

      case ModuleAction.LOGS_SETTINGS:
        return "Cambios de Configuración";

      case ModuleAction.LOGS_SUPPORT:
        return "Cambios de Material de Apoyo";

      case ModuleAction.LOGS_SUPPORT_TEMPLATE:
        return "Cambios de Plantillas";

      case ModuleAction.LOGS_PLANS:
        return "Cambios de Planes";

      case ModuleAction.REPORT_TICKETS_BY_CHANNELS:
        return "Tickets por Canales";

      case ModuleAction.REPORT_TOTAL_TICKETS:
        return "Tickets Totales";

      case ModuleAction.REPORT_TICKETS_BY_DAYS_HOURS:
        return "Tickets por Día y Hora";

      case ModuleAction.REPORT_TICKETS_BY_MONTHS_WEEKS:
        return "Tickets por Meses y Semanas";

      case ModuleAction.REPORT_TICKETS_BY_TYPES:
        return "Tickets por Motivos";

      case ModuleAction.SEE_BRANDS:
        return "Ver Marcas";

      case ModuleAction.SITUATION:
        return "Actualizar situación";

      case ModuleAction.EDIT_HOURS:
        return "Editar horas";

      case ModuleAction.SEE_EDIT_HOURS:
        return "Ver configuración de horas";

      case ModuleAction.EDIT_HOURS_AFTER_CLOSE_REGISTER:
        return "Editar horas luego de cierre de registro";

      default: {
        return String(action);
      }
    }
  }

  public static getModuleInfo(module: AppModules): ModuleInfo {
    switch (module) {
      case AppModules.DASHBOARD:
        return {
          label: "Dashboard",
          path: "/",
          module,
          availableActions: [],
        };

      case AppModules.BLOG:
        return {
          label: "Blog",
          path: "/posts",
          module,
          availableActions: [ModuleAction.CREATE, ModuleAction.DELETE, ModuleAction.UPDATE],
        };

      case AppModules.COMPANIES:
        return {
          label: "Empresas",
          path: "/companies",
          module,
          availableActions: [
            ModuleAction.COMPANY_SUPPORTS,
            ModuleAction.COMPANY_SUPPORT_EXPORT,
            ModuleAction.COMPANY_SUPPORT_UPDATE,
            ModuleAction.COMPANY_CHANNELS,
          ],
        };

      case AppModules.NEWS_SUBSCRIBERS:
        return {
          label: "Clientes",
          path: "/newaletters",
          module,
          availableActions: [ModuleAction.CREATE, ModuleAction.DELETE, ModuleAction.UPDATE],
        };

      case AppModules.PLANS:
        return {
          label: "Planes",
          path: "/plans",
          module,
          availableActions: [ModuleAction.CREATE, ModuleAction.DELETE, ModuleAction.UPDATE],
        };

      case AppModules.REPORTS:
        return {
          label: "Reportes",
          path: "/reports",
          module,
          availableActions: [
            ModuleAction.REPORT_TOTAL_TICKETS,
            ModuleAction.REPORT_TICKETS_BY_TYPES,
            ModuleAction.REPORT_TICKETS_BY_DAYS_HOURS,
            ModuleAction.REPORT_TICKETS_BY_MONTHS_WEEKS,
            ModuleAction.REPORT_TICKETS_BY_CHANNELS,
          ],
        };

      case AppModules.ROLES:
        return {
          label: "Roles",
          path: "/roles",
          module,
          availableActions: [ModuleAction.CREATE, ModuleAction.DELETE, ModuleAction.UPDATE],
        };

      case AppModules.SETTINGS:
        return {
          label: "Configuración",
          path: "/settings",
          module,
          availableActions: [ModuleAction.UPDATE, ModuleAction.ALL],
        };

      case AppModules.USERS:
        return {
          label: "Usuarios",
          path: "/users",
          module,
          availableActions: [
            ModuleAction.CREATE,
            ModuleAction.DELETE,
            ModuleAction.UPDATE,
            ModuleAction.ENABLE,
            ModuleAction.DISABLE,
            ModuleAction.USERS_CHANGE_PASSWORD,
          ],
        };

      case AppModules.CONFIGURATION:
        return {
          label: "Conf de Sistema",
          path: "/settings",
          module,
          availableActions: [], //, ModuleAction.ALL],
        };

      case AppModules.CONTROL_PANEL:
        return {
          label: "Panel de Control",
          path: "/support-access", // control-panel",
          module,
          availableActions: [], // , ModuleAction.ALL],
        };

      case AppModules.CONNECTION_USER:
        return {
          label: "Control de Conexión",
          path: "/connection-user",
          module,
          availableActions: [ModuleAction.ALL],
        };

      case AppModules.QUOTER:
        return {
          label: "Cotizador",
          path: "/quoter",
          module,
          availableActions: [],
        };

      case AppModules.HELP:
        return {
          label: "Ayuda",
          path: "/help",
          module,
          availableActions: [ModuleAction.CREATE, ModuleAction.DELETE, ModuleAction.UPDATE],
        };

      case AppModules.FAQS:
        return {
          label: "FAQS",
          path: "/faqs",
          module,
          availableActions: [ModuleAction.CREATE, ModuleAction.DELETE, ModuleAction.UPDATE],
        };

      case AppModules.CHANNELS:
        return {
          label: "Canales",
          path: "/channels",
          module,
          availableActions: [ModuleAction.UPDATE],
        };

      case AppModules.PLANS_COMPANIES:
        return {
          label: "Empresa-Plan",
          path: "/pc",
          module,
          availableActions: [],
        };

      case AppModules.TICKETS:
        return {
          label: "Tickets",
          path: "/tickets",
          module,
          availableActions: [ModuleAction.UPDATE],
        };

      case AppModules.WEB_ACCESS_LOGS:
        return {
          label: "Acceso Web",
          path: "/web-access",
          module,
          availableActions: [],
        };

      case AppModules.CCENTER:
        return {
          label: "Contact Center",
          path: "/ccenter",
          module,
          availableActions: [ModuleAction.UPDATE],
        };

      case AppModules.STARTING:
        return {
          label: "Starting",
          path: "/starting",
          module,
          availableActions: [],
        };

      case AppModules.SUPPORTS_TEMPLATE:
        return {
          label: "Plantillas",
          path: "/supports/template",
          module,
          availableActions: [ModuleAction.CREATE_AND_UPDATE, ModuleAction.DELETE],
        };

      case AppModules.DIGITAL_SIGNATURE:
        return {
          label: "Firmas Digitales",
          path: "/digital-signature",
          module,
          availableActions: [ModuleAction.CREATE, ModuleAction.DELETE, ModuleAction.UPDATE],
        };

      case AppModules.LOGS:
        return {
          label: "Logs",
          path: "/logs",
          module,
          availableActions: [
            ModuleAction.LOGS_SUPPORT,
            // ModuleAction.LOGS_SUPPORT_TEMPLATE,
            // ModuleAction.LOGS_PLANS,
            // ModuleAction.LOGS_SETTINGS,
          ],
        };

      case AppModules.REVIEWS:
        return {
          label: "Encuestas",
          path: "/reviews",
          module,
          availableActions: [],
        };

      case AppModules.CLAIMS:
        return {
          label: "Reclamos",
          path: "/claims",
          module,
          availableActions: [ModuleAction.TO_LIST],
        };

      case AppModules.INVOICING:
        return {
          label: "Facturación",
          path: "/invoicing",
          module,
          availableActions: [ModuleAction.ALL],
        };

      case AppModules.INVOICES:
        return {
          label: "Facturas",
          path: "/invoicing",
          module,
          availableActions: [ModuleAction.ALL],
        };

      case AppModules.ACCESO_SOPORTE:
        return {
          label: "Acceso Soporte",
          path: "/support-access",
          module,
          availableActions: [],
        };

      case AppModules.HELPIA_PEOPLE:
        return {
          label: "Helpia people",
          path: "/people/agents", // helpia-people",
          module,
          availableActions: [], //, ModuleAction.ALL],
        };

      case AppModules.HISTORICO:
        return {
          label: "Historico",
          path: "/logs", // historico",
          module,
          availableActions: [], //, ModuleAction.ALL],
        };

      case AppModules.COMERCIAL:
        return {
          label: "Comercial",
          path: "/starting", // comercial",
          module,
          availableActions: [], //, ModuleAction.ALL],
        };

      case AppModules.PANEL_EMPRESA:
        return {
          label: "Panel Empresa",
          path: "/companies", // copanel-empresa",
          module,
          availableActions: [], //, ModuleAction.ALL],
        };

      //Helpia People Modules
      case AppModules.HELPIA_PEOPLE_AGENT:
        return {
          label: "Agentes",
          path: "/people/agents",
          module,
          availableActions: [
            ModuleAction.CREATE,
            ModuleAction.UPDATE,
            ModuleAction.DELETE,
            ModuleAction.SITUATION,
            ModuleAction.SEE_BRANDS,
          ],
        };

      case AppModules.HELPIA_PEOPLE_PROJECT:
        return {
          label: "Proyectos",
          path: "/people/projects",
          module,
          availableActions: [],
        };

      case AppModules.HELPIA_PEOPLE_BRAND:
        return {
          label: "Marcas",
          path: "/people/brands",
          module,
          availableActions: [
            ModuleAction.EDIT_HOURS,
            ModuleAction.SEE_EDIT_HOURS,
            ModuleAction.EDIT_HOURS_AFTER_CLOSE_REGISTER,
          ],
        };

      case AppModules.HELPIA_PEOPLE_REPORTS:
        return {
          label: "Reportes",
          path: "/people/reports",
          module,
          availableActions: [],
        };

      case AppModules.GENERAL_REPORTS:
        return {
          label: "Reportes",
          path: "/resume-reviews",
          module,
          availableActions: [],
        };

      case AppModules.RESUMEN_ENCUESTA:
        return {
          label: "Resumen de encuestas",
          path: "/resume-reviews",
          module,
          availableActions: [],
        };

      case AppModules.DYNAMIC_REPORT:
        return {
          label: "Reporte dinámico",
          path: "/reports",
          module,
          availableActions: [ModuleAction.DETAILS],
        };

      default: {
        return {
          label: "--",
          path: "/404",
          module,
          availableActions: [],
        };
      }
    }
  }

  public static getTranslatedModule(module: string): string {
    switch (module) {
      case AppModules.USERS:
        return "USUARIOS";
      case AppModules.CLAIMS:
        return "RECLAMOS";
      case AppModules.SETTINGS:
        return "CONFIGURACION";
      case AppModules.PLANS:
        return "PLANES";
      case AppModules.COMPANIES:
        return "EMPRESAS";
      case AppModules.HELP:
        return "AYUDA";
      case AppModules.CHANNELS:
        return "CANALES";
      case AppModules.SUPPORTS_TEMPLATE:
        return "PLANTILLAS";
      case AppModules.DIGITAL_SIGNATURE:
        return "FIRMAS DIGITALES";
      case AppModules.CONNECTION_USER:
        return "CONTROL DE CONEXION";
      case AppModules.CCENTER:
        return "CONTACT CENTER";
      case AppModules.HELPIA_PEOPLE_AGENT:
        return "AGENTES";
      case AppModules.HELPIA_PEOPLE_BRAND:
        return "MARCAS";
      default: {
        return "--";
      }
    }
  }
}
